import { render } from "./PlayLists.vue?vue&type=template&id=bc505fc8&scoped=true"
import script from "./PlayLists.vue?vue&type=script&lang=js"
export * from "./PlayLists.vue?vue&type=script&lang=js"

import "./PlayLists.vue?vue&type=style&index=0&id=bc505fc8&scoped=true&lang=css"

import exportComponent from "/home/tamo/projects/wedio/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc505fc8"]])

export default __exports__